export default function fixedBuyBox() {
    const BOX_FIXED_CLASS = 'box-fixed'
    const box = document.getElementById('buy-box');
    if(!box) return;
    
    function handleScroll(el) {
        const nextElPosition = el.nextElementSibling.getBoundingClientRect();
        if (nextElPosition.top < 0) {
            el.classList.add(BOX_FIXED_CLASS);
            return
        } 
        el.classList.remove(BOX_FIXED_CLASS);    
    }

    if (window.innerWidth < 1024) {
        window.addEventListener('scroll', () => handleScroll(box));
    }
}